// extracted by mini-css-extract-plugin
export default {"SourceLink":"_WRQ95ptL34dOt1sMrJl","plainSource":"V7eFLKcyu9g8SogD89yF"};